<div class="row m-b-xs" (dblclick)="editModeOn()">
    <div *ngIf="title"
         class="dv-label strong col-sm-3"
         data-toggle="tooltip"
         data-placement="top"
         [title]="tooltipText">
        {{ title }}
    </div>
    <div *ngIf="!editOnly"
         class="dv-value"
         [ngClass]="{'col-sm-9': title, 'col-sm-12': !title}"
         [class.hidden]="isEditMode">
        <span *ngFor="let group of value" class="group-label m-b-xs">
            {{group.itemName}}
        </span>

        <span *ngIf="!value?.length" class="m-b-xs" style="text-decoration: underline;">
            Please select
        </span>

        <i *ngIf="!noEdit" class="fa fa-pencil pull-right" (click)="editModeOn()"
           data-toggle="tooltip" data-placement="top" title="Edit"></i>
    </div>

    <div class="dv-value"
         [class.hidden]="!isEditMode"
         style="overflow: visible;"
         [ngClass]="{'col-sm-9': title, 'col-sm-12': !title}">
        <div *ngIf="!editOnly" class="col-sm-2 row m-t-xs apart-btns pull-right" style="padding: 0;">
            <button type="button" class="apply" (click)="apply()">
                <i class="fa fa-check"></i>
            </button>

            <button type="button" class="reset" (click)="cancel()">
                <i class="fa fa-times"></i>
            </button>
        </div>
        <div class="col-sm-10" style="padding: 0;">
            <angular2-multiselect
                [data]="data"
                [(ngModel)]="value"
                [settings]="multiselectSettings">
            </angular2-multiselect>
        </div>
    </div>
</div>




// WEBPACK FOOTER //
// /app/src/app/components/fields/multiselect-field/multiselect-field.component.html